import React from 'react';
import styled from 'styled-components';
import { device } from 'js/config/style.js';

const PrimaryContainer = styled.div`
  position: relative;
  background: ${({ color, background }) => color || background || 'white'};
  display: flex;
  flex-direction: row;
  padding: 5px 10px;
  border-radius: 7px;
  justify-content: space-evenly;
  flex-wrap: wrap;
  @media(min-width: ${device.tablet}) {
    align-items: stretch;
  };
  @media(max-width: ${device.tablet}) {
    flex-direction: column;
    padding: 0px;
    width: 100%;
    margin: 10px 10px;
  };
`;

// @media(max-width: ${device.mobile}) {
//   flex-direction: column;
// };

export default ({ className, ...rest }) => <PrimaryContainer className={className} {...rest} />;
